<template>
  <div :class="{'quiz-sidebar': activeQuiz && activeQuiz.display_type === 'sidebar'}">
    <div v-if="activeQuiz && activeQuiz.display_type === 'sidebar'">
      <div class="d-flex align-items-start justify-content-between quiz-sidebar-left">
        <span class="close-quize-des">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><path
            clip-rule="evenodd"
            d="m5.00073 17.5864c-.3905.3906-.39044 1.0237.00012 1.4142s1.02372.3905 1.41421-.0001l5.58524-5.5862 5.5857 5.5857c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-5.5858-5.5858 5.5854-5.58638c.3904-.39056.3904-1.02372-.0002-1.41421-.3905-.3905-1.0237-.39044-1.4142.00012l-5.5853 5.58627-5.58572-5.58579c-.39052-.39052-1.02369-.39052-1.41421 0-.39053.39053-.39053 1.02369 0 1.41422l5.58593 5.58587z"
            fill="rgb(0,0,0)" fill-rule="evenodd"/>
        </svg>
        </span>
        <div class="d-flex flex-column w-100">
          <div class="quiz-sidebar-description" v-html="activeQuiz.sidebar_text"></div>

          <div class="quiz-sidebar-description" v-if="activeQuiz.sidebar_attachments && activeQuiz.sidebar_attachments.length">
            {{ trans('Attachments') }}
            <div v-for="file in activeQuiz.sidebar_attachments" class="mt-1">
              <a :href="file.file" target="_blank">
                <img :src="`${m_cloud_url}uteach/assets/download-2.svg`" alt="download" width="12" height="13">
                {{ file.original_name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <all-questions-one-page v-if="activeQuiz" :userId="userId"/>

    <div class="skeleton-loading-container" v-else-if="shouldShowSkeleton">
      <div class="d-flex justify-content-center">
        <div style="width: 100%; max-width: 720px;">
          <div class="mb-4">
            <div class="skeleton-loading" style="width: 45%; height: 14px;"></div>
            <div class="skeleton-loading mt-2" style="width: 100%; height: 44px;"></div>
          </div>

          <div class="mb-4">
            <div class="skeleton-loading" style="width: 55%; height: 14px;"></div>
            <div class="skeleton-loading mt-2" style="width: 100%; height: 44px;"></div>
          </div>

          <div class="mb-4">
            <div class="skeleton-loading" style="width: 40%; height: 14px;"></div>
            <div class="skeleton-loading mt-2" style="width: 100%; height: 44px;"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else></div>

    <a
      v-if="showUteachBranding"
      href="https://uteach.io"
      target="_blank"
      style="background-color: #F4F5F8;"
      class="text-center mx-auto d-block text-secondary">
      {{ trans('built with Uteach') }}
    </a>
  </div>
</template>

<script>
import Vue from 'vue';
import AllQuestionsOnePage from "../components/AllQuestionsOnePage";
import {mapMutations} from "vuex";

Vue.mixin({
  methods: {
    onConfirmHandler() {
      if (this.$route?.query?.preview) {
        return;
      }

      $('.loader').addClass('show');
      let url = `/forms/${this.$route?.params?.id ?? window._id}/confirm`;

      const allowedParams = ['course_id', 'source_id', 'source_type', 'episode_id'];
      let params = [];

      try {
        for (const queryKey in this.$route.query) {
          if (allowedParams.includes(queryKey)) {

            params.push({
              name: queryKey,
              value: this.$route.query[queryKey],
            });
          }
        }

        params = params.map(({name, value}) => `${name}=${value}`).join('&');
      } catch (e) {

      }

      if (params) {
        url += `?${params}`;
      }

      axios.post(url, {
        answers: this.$store.state.userAnswers,
        duration: this.$store.state.duration,
        email: this.$store.state.email,
        name: this.$store.state.name,
        question_ids: this.$store.state.activeQuiz.questions.map(question => question.id)
      }).then(res => {
          $('.loader').removeClass('show');

          if (!res.data.success) {
              toastr.error(res.data.message);
          } else {
            try {
              this.$router.push({name: 'confirm', params: {id: res.data.report.id}});
            } catch (e) {
              toastr.success(window.formSuccessfullySent || trans('The form successfully sent', 'form'));

              setTimeout(() => {
                window.location.reload();
              }, 2000)
            }
          }
      })
    }
  },
  computed: {
    showUteachBranding() {
      return !window.hasAccessForm;
    }
  }
})

export default {
  name: "Start",
  components: {
    'all-questions-one-page': AllQuestionsOnePage,
  },
  props: {
    showSkeleton: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      shouldShowSkeleton: false,
    };
  },
  methods: {
    ...mapMutations(['fetchQuiz', 'runDuration'])
  },
  computed: {
    id() {
      try {
        return this.$route.params.id
      } catch (e) {
        return this.$attrs.id;
      }
    },
    userId() {
      try {
        return this.$attrs.user_id;
      } catch (e) {
        return this.$attrs.user_id;
      }
    }
  },
  beforeMount() {
    window._id = this.id;

    const v = this.showSkeleton;
    this.shouldShowSkeleton = v === true
      || v === ''
      || v === 'true'
      || v === '1';

    this.fetchQuiz({ id: this.id, showSkeleton: this.shouldShowSkeleton });
    this.runDuration();
  },
}
</script>

<style scoped>
.skeleton-loading {
    background: #ededed linear-gradient(
            100deg,
            rgba(255, 255, 255, 0) 40%,
            rgba(255, 255, 255, .5) 50%,
            rgba(255, 255, 255, 0) 60%
    );
    background-size: 200% 100%;
    background-position-x: 180%;
    animation: 1s skeleton_loading ease-in-out infinite;
    min-height: 1.6rem;
    width: 100px;
    height: 25px;
    animation-delay: .05s;
    margin: 5px 0;
}

@keyframes skeleton_loading {
    to {
        background-position-x: -20%;
    }
}
</style>